<script lang="ts">

    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../naui/atoms/NauiButton.svelte";
    import {Cart} from "../models/cart";
    import {createEventDispatcher} from "svelte";
    import Snackbar, {Label} from "@smui/snackbar";
    import IconButton from "@smui/icon-button";

    const dispatch = createEventDispatcher();

    export let cart: Cart;
    let snackbarCmpt;
    let dialog = {
        open: false
    }
    let messageSnack;

    function shareCart() {
        dialog.open = true;
    }

    function copy() {
        try {
            navigator.clipboard.writeText(cart.share);
            messageSnack = 'Se ha copiado el link al portapapeles';

        } catch (e) {
            messageSnack = 'Se ha presentado un error al copiar el link al portapapeles';
        }
        snackbarCmpt.open();
        dispatch('close');
        dialog.open = false;
    }

    function closeDialog() {
        dispatch('close');
        dialog.open = false;
    }
</script>

<div class="box mt-1">
    <a on:click={()=>shareCart()} class="underlined">Compartir Carrito</a>
</div>

<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        Link para compartir el carrito de compras <b>{cart.share}</b>
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="COPIAR"
                        on:click={()=>copy()}/>
            <NauiButton caption="ACEPTAR"
                        color="accent"
                        mode="solid"
                        on:click={()=>closeDialog()}/>
        </div>
    </Actions>
</Dialog>

<Snackbar bind:this={snackbarCmpt}>
    <Label>{messageSnack}</Label>
    <Actions>
        <IconButton class="material-icons" title="Dismiss" on:click={()=>snackbarCmpt.close()}>close</IconButton>
    </Actions>
</Snackbar>